import { Select } from "@cofano/cck";
import { SelectProps } from "@cofano/cck/Select/Select";
import { WeightUnit } from "__generated__/graphql";
import { intl } from "LocaleWrapper";

type WeightUnitSelectProps = Omit<SelectProps<WeightUnit, false>, "fetchOptions"> & {
	onlyKg?: boolean;
};
const WeightUnitSelect = ({ value, onChange, disabled, clearable, onlyKg }: WeightUnitSelectProps) => {
	return (
		<Select
			fetchOptions={() => Object.values(WeightUnit).filter(x => (onlyKg ? x !== WeightUnit.Mton : true))}
			getOptionLabel={option => intl.formatMessage({ id: intl.formatMessage({ id: `UNIT_${option}` }) })}
			value={value}
			disabled={disabled}
			onChange={onChange}
			clearable={clearable}
			disableSearch />
	);
};

export default WeightUnitSelect;
